import React from 'react';
import DownloadIcon from '@mui/icons-material/Download';
import { Grid } from '@material-ui/core';
import { Provider } from 'models';
import { downloadFile, getLinks } from './DocumentShared';
import Colors from 'constants/Colors';

export default function DownloadAllDocuments({ provider }: { provider: Provider }) {
    const links = getLinks(provider);

    function download() {
        links.forEach((link) => {
            downloadFile(link.url);
            if (link.type === 'link') {
                window.open(link.url, '_blank');
            }
        });
    }
    return (
        <Grid onClick={download} style={{ cursor: 'pointer' }}>
            <DownloadIcon htmlColor={Colors.darkNavy} />
        </Grid>
    );
}
